var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-dropdown-divider'),_c('b-dropdown-text',[_vm._v(" Documentos Excel ")]),_c('b-dropdown-item',{on:{"click":_vm.export_excel}},[_c('i',{staticClass:"icon-share"}),_vm._v(" Exportar Excel ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }